import { render, staticRenderFns } from "./VEmployeeGuide.vue?vue&type=template&id=ae30cfa8&lang=pug"
import script from "./VEmployeeGuide.vue?vue&type=script&lang=ts"
export * from "./VEmployeeGuide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports